import React, { lazy, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { configureAxios } from '../utils/axiosInstance';
import ProtectedRoute from './ProtectedRoute';

const ServerError = lazy(() => import('../components/ServerError'));
const NetworkError = lazy(() => import('../components/NetworkError'));
const NotFound = lazy(() => import('../components/NotFound'));
const MainLayout = lazy(() => import('../components/MainLayout'));

const Home = lazy(() => import('../pages/home/Home'));
const Login = lazy(() => import('../pages/home/Login'));

const Store = lazy(() => import('../pages/store/Store'));
const SalesTransaction = lazy(() => import('../pages/store/SalesTransaction'));
// IBK BaaS 결제 관리 페이지 - 박지성 2026-03-31
const PaymentManagement = lazy(() => import('../pages/store/PaymentManagement'));


const Manager = lazy(() => import('../pages/manager/Manager'));
const NoticeForm = lazy(() => import('../pages/board_notice/NoticeForm'));
const Notice = lazy(() => import('../pages/board_notice/Notice'));
const PdsForm = lazy(() => import('../pages/board_pds/PdsForm'));
const Pds = lazy(() => import('../pages/board_pds/Pds'));
const SuggestForm = lazy(() => import('../pages/board_suggest/SuggestForm'));
const Suggest = lazy(() => import('../pages/board_suggest/Suggest'));
const Category = lazy(() => import('../pages/category/Category'));
const Company = lazy(() => import('../pages/company/Company'));
const Product = lazy(() => import('../pages/product/Product'));
const Order = lazy(() => import('../pages/order/Order'));

const SalesStatement = lazy(() => import('../pages/api/SalesStatement'));
const SalesSummary = lazy(() => import('../pages/api/SalesSummary'));



function AppRoutes() {
  const { isAuthenticated } = useAuth();

  const navigate = useNavigate();
  useEffect(() => {
    configureAxios(navigate);
  }, [navigate]);


  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<ProtectedRoute element={<Notice />} />} />
        
        <Route path="/company" element={<ProtectedRoute element={<Company />} />} />
        <Route path="/notice/form" element={<ProtectedRoute element={<NoticeForm />} />} />
        <Route path="/notice/form/:id" element={<ProtectedRoute element={<NoticeForm />} />} />
        <Route path="/notice" element={<ProtectedRoute element={<Notice />} />} />
        <Route path="/pds/form" element={<ProtectedRoute element={<PdsForm />} />} />
        <Route path="/pds/form/:id" element={<ProtectedRoute element={<PdsForm />} />} />
        <Route path="/pds" element={<ProtectedRoute element={<Pds />} />} />
        <Route path="/suggest/form" element={<ProtectedRoute element={<SuggestForm />} />} />
        <Route path="/suggest/form/:id" element={<ProtectedRoute element={<SuggestForm />} />} />
        <Route path="/suggest" element={<ProtectedRoute element={<Suggest />} />} />
        <Route path="/category" element={<ProtectedRoute element={<Category />} />} />
        <Route path="/store" element={<ProtectedRoute element={<Store />} />} />
        <Route path="/sales-transaction" element={<ProtectedRoute element={<SalesTransaction />} />} />
        {/* IBK BaaS 결제 관리 라우트 - 박지성 2026-03-31 */}
        <Route path="/payment-management" element={<ProtectedRoute element={<PaymentManagement />} />} />
<Route path="/manager" element={<ProtectedRoute element={<Manager />} />} />
        <Route path="/product" element={<ProtectedRoute element={<Product />} />} />
        <Route path="/order" element={<ProtectedRoute element={<Order />} />} />

        <Route path="/api/statement/:id" element={<ProtectedRoute element={<SalesStatement />} />} />
        <Route path="/api/summary/:id" element={<ProtectedRoute element={<SalesSummary />} />} />


      </Route>


      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/server-error" element={<ServerError />} />
      <Route path="/network-error" element={<NetworkError />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;